import { useEffect, useState } from "react";
import { GrFormPrevious } from "react-icons/gr";
import Media from "./Media/Media";
import Links from "./Links/Links";
import Documents from "./Documents/Documents";

export default function MediaLinks({
  setActiveSection,
  setShowProfileView,
  mediaList,
  linkList,
  documentsList,
  isMediaLoading,
  getMediaList,
  mediaCurrentPage,
  mediaTotalPage,
  linkCurrentPage,
  linkTotalPage,
  documentsCurrentPage,
  documentsTotalPage,
  chatConversationId,
  secretKey,
  activeTab,
  setActiveTab,
}) {
  const tabs = ["MEDIA", "LINK", "DOCUMENT"];

  useEffect(() => {
    setActiveTab("MEDIA");
  }, []);

  const renderContent = () => {
    switch (activeTab) {
      case "MEDIA":
        return (
          <div>
            <Media
              mediaList={mediaList}
              isMediaLoading={isMediaLoading}
              getMediaList={getMediaList}
              mediaCurrentPage={mediaCurrentPage}
              mediaTotalPage={mediaTotalPage}
              chatConversationId={chatConversationId}
            />
          </div>
        );
      case "LINK":
        return (
          <div>
            <Links
              linkList={linkList}
              isMediaLoading={isMediaLoading}
              getMediaList={getMediaList}
              linkCurrentPage={linkCurrentPage}
              linkTotalPage={linkTotalPage}
              chatConversationId={chatConversationId}
              secretKey={secretKey}
            />
          </div>
        );
      case "DOCUMENT":
        return (
          <div>
            <Documents
              documentsList={documentsList}
              isMediaLoading={isMediaLoading}
              getMediaList={getMediaList}
              documentsCurrentPage={documentsCurrentPage}
              documentsTotalPage={documentsTotalPage}
              chatConversationId={chatConversationId}
            />
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <section>
      <div className="sticky  w-full min-h-[67px] py-2.5 bg-white flex items-center justify-between border-b  text-black p-4 text-center">
        <div className="">
          <div className="w-full items-center bg-white text-black flex gap-4 ">
            <GrFormPrevious
              onClick={() => setActiveSection("contact")}
              className="cursor-pointer hover:text-[var(--primary-color)] h-8 w-8 p-1  border rounded-md"
            />
          </div>
        </div>
      </div>
      <div className="bg-[#fff] justify-center h-[calc(100vh-80px)] min-h-[calc(100vh-80px)] max-h-[calc(100vh-80px)] gap-2 overflow-y-auto overflow-x-hidden">
        <div className="flex bg-[#f9f6fe] items-center gap-2 p-1 pt-0">
          <div className="bg-white rounded-lg w-full px-0 pb-0 pt-2">
            <div className="grid grid-cols-3 gap-2">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`w-full py-2 font-medium text-sm transition-all  ${
                    activeTab === tab
                      ? "border-b-2 border-[#7104F8] text-[#7104F8] font-medium"
                      : "border-b-2 border-white text-gray-700"
                  }`}
                >
                  {tab === "LINK" || tab === "DOCUMENT" ? `${tab}S` : tab}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="p-4">{renderContent()}</div>
      </div>
    </section>
  );
}
